
export const serviceChannelUploadEditColumnDef = [
  { "headerName": "Errors", "field": "errors", filter: 'agTextColumnFilter' },
  { "headerName": "Order No", "field": "orderNo", filter: 'agTextColumnFilter' },
  { "headerName": "Order Date", "field": "orderDate", filter: 'agTextColumnFilter' },
  { "headerName": "RM", "field": "rm", filter: 'agTextColumnFilter' },
  { "headerName": "CSC", "field": "csc", filter: 'agTextColumnFilter' },
  { "headerName": "TC", "field": "tc", filter: 'agTextColumnFilter' },
  { "headerName": "REF", "field": "ref", filter: 'agTextColumnFilter' },
  { "headerName": "POSP", "field": "posp", filter: 'agTextColumnFilter' },

]
